import { HandleAddToCollectionDialog } from "../collections/dialogs/HandleAddToCollectionDialog"
import MultiEditDialog from "./MultiEditDialog/MultiEditDialog"
import Commandbar from "./Commandbar"
import { EditSkuTagsDialog } from "./Tags/EditSkuTagsDialog"
import { useVariantsByIds } from "~/hooks/useVariants"
import { getCommonVendors } from "~/utils/vendorUtils"
import { type IVariantSummary } from "~/hooks/useVariantTableData"

type MultiEditSkuSettingsPanelProps = {
  selectedVariantIds: string[]
  selectedVariantCount: number
  clearSelectedIds: () => void
}

export function MultiEditSkuSettingsPanel({
  selectedVariantIds,
  selectedVariantCount,
  clearSelectedIds,
}: MultiEditSkuSettingsPanelProps) {
  const variants = useVariantsByIds(selectedVariantIds)
  const skuIds = variants.flatMap((v: IVariantSummary) => v.skuIds)
  const commonVendors = getCommonVendors(variants)

  return (
    <>
      {selectedVariantCount > 0 && (
        <Commandbar count={selectedVariantCount} onClear={clearSelectedIds}>
          <MultiEditDialog
            selectedSkuIds={skuIds}
            selectedVariantCount={selectedVariantCount}
            resetSelectedProductIds={clearSelectedIds}
            commonVendors={commonVendors}
          />
          <EditSkuTagsDialog variantIds={selectedVariantIds} />
          <HandleAddToCollectionDialog variantIds={selectedVariantIds} />
        </Commandbar>
      )}
    </>
  )
}
